import{resolveVariantFromProps as o}from"./resolve-variants.mjs.js";function r(r,t,s){const e=r.getProps();return o(e,t,void 0!==s?s:e.custom,r)}export{r as resolveVariant};
